export const FLAG_GETTING_CREDIT_NOTES = 'FLAG_GETTING_CREDIT_NOTES';
export const GET_CREDIT_NOTES = 'GET_CREDIT_NOTES';
export const CLEAR_CREDIT_NOTES = 'CLEAR_CREDIT_NOTES';
export const GET_CREDIT_NOTE = 'GET_CREDIT_NOTE';
export const CLEAR_CREDIT_NOTE = 'CLEAR_CREDIT_NOTE';
export const FLAG_CREDIT_NOTE_ACTIVITY = 'FLAG_CREDIT_NOTE_ACTIVITY';
